import { Box, Typography } from '@mui/material';

interface EmptyGoalsProps {
  mode: 'inProgress' | 'completed';
}

export const EmptyGoals = ({ mode }: EmptyGoalsProps) => {
  const message =
    mode === 'inProgress'
      ? 'All of your goals are complete!'
      : `Looks like we've got work to do!`;

  const emoji = mode === 'inProgress' ? '🎉' : '📋';

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        rowGap: '16px',
        padding: '25px 16px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Typography component="div" variant="titleLarge">
        {message}
      </Typography>
      <Typography component="div" variant="displayLarge">
        {emoji}
      </Typography>
    </Box>
  );
};
